import React, { useEffect, useState } from "react";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate, useParams } from "react-router-dom";
import OverviewTab from "./components/Overview";
import SettingsTab from "./components/Settings";
import { tenantService } from "../../../services/tenantService";



const TenantConfig: React.FC = () => {
  const navigate = useNavigate();
  const { tenantId } = useParams<{ tenantId: string }>();

  const [tenant, setTenant] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");

   const fetchTenantDetails = async (tenantId: string) => {
      try {
        setLoading(true);
        const res: any = await tenantService.get(tenantId);
        setTenant(res?.stats);
      } catch (err) {
        console.error("Failed to load tenant details", err);
      } finally {
        setLoading(false);
      }
    };
  

  useEffect(() => {
    if (tenantId) {
      fetchTenantDetails(tenantId);
    }
  }, [tenantId]);

  const tabs = [
    { id: "overview", name: "Overview" },
    { id: "settings", name: "Settings" },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      {/* HEADER */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 py-6 flex items-center space-x-4">
          <button onClick={() => navigate("/tenant-listing")} className="p-2 text-gray-600 hover:text-black">
            <ArrowLeftIcon className="h-5 w-5" />
          </button>

          <div>
            <h1 className="text-2xl font-bold">{tenant?.tenant?.name || "Tenant"}</h1>
            <p className="text-sm text-gray-500">Tenant Configuration</p>
          </div>
        </div>
      </div>

      {/* TABS */}
       <div className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex space-x-8" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`py-4 px-1 border-b-2 text-sm font-medium transition ${
                activeTab === tab.id
                  ? "border-blue-600 text-blue-600"
                  : "border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300"
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>
    </div>

      {/* TAB CONTENT */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="bg-white rounded-xl shadow p-6 min-h-[300px]">

          {loading ? (
            <div>Loading...</div>
          ) : activeTab === "overview" ? (
            <OverviewTab tenant={tenant} />
          ) : activeTab === "settings" ? (
            <SettingsTab 
                tenant={tenant?.tenant}
                refetch={() => {
                    if (tenantId) {
                        fetchTenantDetails(tenantId);
                    }
                }}
            />
          ) : null}

        </div>
      </div>
    </div>
  );
};

export default TenantConfig;
